import { render, staticRenderFns } from "./FollowRecords.vue?vue&type=template&id=345a76b2&scoped=true"
import script from "./FollowRecords.vue?vue&type=script&lang=js"
export * from "./FollowRecords.vue?vue&type=script&lang=js"
import style0 from "./FollowRecords.vue?vue&type=style&index=0&id=345a76b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345a76b2",
  null
  
)

export default component.exports